/* Component Dependencies */
var termsAndConditionsTemplate = require('templates/termsAndConditions.hbs');
var SendToLinkComponent = require('libs/send-to-link');

SendToLinkComponent.create({
  type: 'termsAndConditions',

  template: {
    'termsAndConditions': termsAndConditionsTemplate
  },

  bindEvents: function () {
    this.$el.find('.js-sent-to-link').on('click', this.sendToLink);
  }
});
